

import React from "react";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';


function GTCReportTable(props: any) {
	const items = props.items;


	return (
		<Paper sx={{ width: '100%', overflow: 'hidden' }}>
			<TableContainer sx={{ maxHeight: 440 }}>
				<Table stickyHeader aria-label="sticky table">
					<TableHead>
						<TableRow>
							<TableCell style={{ fontWeight: 600 }}>
								Origin
							</TableCell>
							<TableCell style={{ fontWeight: 600 }}>
								Referer
							</TableCell>
							<TableCell style={{ fontWeight: 600 }}>
								Country
							</TableCell>
							<TableCell style={{ fontWeight: 600 }}>
								Target
							</TableCell>
							<TableCell style={{ fontWeight: 600 }}>
								Time
							</TableCell>
							<TableCell align={'right'}>
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{
							items.map((item: any, i: any) => {
								return (
									<TableRow hover role="checkbox" tabIndex={-1} key={i}>
										<TableCell>
											{item.data.origin || ""}
										</TableCell>
										<TableCell>
											{item.data.referer || ""}
										</TableCell>
										<TableCell>
											{item.data.cc || ""}
										</TableCell>
										<TableCell>
											{item.data.target || ""}
										</TableCell>
										<TableCell>
											{new Date(item.data.ts).toLocaleString()}
										</TableCell>
										<TableCell align={'right'}>
											<a href={item.data.url} target="_blank" style={{ color: "var(--secondary-color)"}}>
											<FontAwesomeIcon
												 icon={faDownload} 
												 style={{ cursor: "pointer"}}/>
											</a>
										</TableCell>	
									</TableRow>
								);
							})
						}

					</TableBody>
				</Table>
			</TableContainer>
		</Paper>
	);
}

export default GTCReportTable;